module.exports = {"aggressive":"Agressif","unfriendly":"Inamical","neutral":"Neutre","friendly":"Amical","awakened":"Éveillé"};